module.exports = __webpack_public_path__ + "static/img/industry1.b5b7600.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/industry1.png
// module id = ezTi
// module chunks = 0